import { Navigate, useLocation } from 'react-router-dom';
import { SettingsLayout } from '@/components/shell/SettingsLayout';
import { ROUTES } from '@/lib/routes';

/** Personal settings (`/account/*`) — framed by the shared Settings layout (⚙ in the header). */
export default function AccountPage() {
  const loc = useLocation();
  if (loc.pathname === ROUTES.account.root || loc.pathname === `${ROUTES.account.root}/`) {
    return <Navigate to={ROUTES.account.info} replace />;
  }
  return <SettingsLayout />;
}
